export default {
  hizli_triple_word: "Açık olan karttaki kelime, kapalı olan kartlarda var mı?",
  hizli_triple_shape: "Açık olan karttaki şekil ve renk, kapalı olan kartlarda var mı?",
  kar_title: "Kardan adamın yardımına ihtiyacı var !",
  kar_desc: "Kar taneleri yere düşmeden problemleri çözmen gerekiyor, problemleri çözmek için klavyedeki rakamları kullanıp sonucu yaz ve enter tuşuna bas.",
  bavul_desc: "bavul kapandığında herhangi bir eşyaya denk gelmeyecek şekilde sol taraftaki boş bir bölmeye yerleştirin.",
  goremedim: "Göremedim",
  cevapla: "Cevapla",
  login: {
    email: "E-Posta",
    password: "Şifreniz",
    login: "Giriş Yap",
    forgot: "Şifremi Unuttum"
  },
  app: {
    hello: "İyi Günler",
    hello_description: `Bilim adamları, ruh hali ve uykunun bilişsel performansı
    etkileyebileceğini göstermiştir. Kendi eğilimlerinizi takip
    edebilmeniz için bu verileri kaydedin.`,
    howareu: "Bugün Nasılsın?",
    sleep: "Kaç Saat Uyudun?",
    save: "Kaydet",
    five: "5 veya daha az",
    nine: "9 veya üzeri",
    cokkotu: "Çok Kötü",
    kotu: "Kötü",
    idareeder: "İdare Eder",
    good: "İyi",
    super: "Süper!"
  },
  header: {
    tests: "Testler",
    logout: "Çıkış Yap",
    home: "ANA EKRAN",
    education: "EĞİTİMLER",
    exercises: "EGZERSİZLER"
  },
  pause: {
    paused: "Duraklatıldı",
    continue: "Devam Etmek İçin Tıklayın"
  },
  coursedetail: {
    step: "Egzersiz",
    second: "saniye",
    start: "BAŞLA",
    confirm: "Egzersiz henüz bitmedi, eğer çıkarsanız bu egzersizin verileri kaydedilmeyecek.",
    done: "Bugünkü Egzersizleri Bitirdiniz.",
    zoom: "Ortada gördüğünüz kutu büyük veya küçükse sağdaki butonlardan veya sağ üstteki butonlardan büyütüp küçültebilirsiniz."
  },
  courses: {
    courses: "Eğitimler",
    description: `Size özel tanımlanan bu eğitim ile;<br />
    - Göz kaslarınızı eğitecek,<br />
    -Gözünüzün çevik görmesini sağlayacak,<br />
    - Görme alanınızı genişletecek,<br />
    - Gözleriniz satırların üzerinde daha hızlı ve etkin bir şekilde ritim
    kazanacak,<br />
    Böylece görme + algılama uyumunu sağlayarak daha hızlı okuyacaksınız.`,
    total_day: "Toplam Kurs Süresi:",
    finished_day: "Bitirilen Gün: {day}",
    day: "Gün",
    canrepeat: "Tekrar edilebilir {day} gün ve {exercise} egzersiz var.",
    repeat: "Tekrar Et",
    repeat_step: "{step}. Gün",
    start_repeat: "Tekrara Başla",
    continue_repeat: "Tekrara Devam Et",
    start: "Başla"
  },
  edetail: {
    start: "BAŞLA"
  },
  e: {
    welcome: "Egzersizlere Hoşgeldin",
    description: `Hızlı okuma gelişim için gereken ve ihtiyacın olan tüm egzersiz
    tiplerinden dilediğini seçip başlayabilirsin`
  },
  cats: {
    "Göz Egzersizleri": "Göz Çalışmaları",
    "Dikkat & Odaklanma": "Dikkat & Odaklanma",
    Hız: "Hız",
    Hafıza: "Hafıza",
    "Okuma & Anlama": "Okuma & Anlama",
    test: "Okuma Hızı Testi",
    "Zihinsel Matematik": "Zihinsel Matematik",
    Video: "Video Anlatım"
  },
  module: {
    start: "BAŞLA",
    speed: "HIZ",
    object_count: "NESNE SAYISI",
    eksen: "EKSEN",
    direction: "EKSEN",
    horizontal: "YATAY",
    vertical: "DİKEY",
    autolevel: "OTOMATİK ARTIŞ",
    yes: "EVET",
    no: "HAYIR",
    time: "ZAMAN",
    level: "SEVİYE",
    rows: "SATIR",
    cols: "SÜTUN",
    benzerkelimeler: {
      description: "Farklı kelimeler olan blokları isaretleyiniz"
    },
    wordperminute: "Kelime/Dakika",
    start_again: "Tekrar Başla",
    charlevel: "KARAKTER SEVİYESİ",
    screenwidth: "EKRAN GENİŞLİĞİ",
    screenheight: "EKRAN YÜKSEKLİĞİ",
    short: "KISA",
    mid: "ORTA",
    long: "UZUN",
    cevrefokus: {
      description: "Ekranda gördüğünüz kelime/kelimeleri yazınız"
    },
    group: "GRUP & GRUP DEĞİL",
    same: "AYNI & AYNI DEĞİL",
    mode: "MOD",
    isgroup: "GRUP",
    issame: "AYNI",
    isnotgroup: "GRUP DEĞİL",
    isnotsame: "AYNI DEĞİL",
    level_completed: "Bölüm Tamamlandı",
    point: "Puanınız:",
    continue: "Devam Et",
    show_time: "GÖRÜNME SÜRESİ",
    farkliolan: {
      description: "Dilimi bozan karakterleri isaretleyiniz"
    },
    showing_word: "VURGULANAN KELIME",
    marquee: "KAYAN YAZI",
    start_again: "Tekrar Başla",
    read_speed: "Okuma Hızınız: {speed} kelime/dakika",
    attention: "DİKKAT MODU",
    open: "AÇIK",
    close: "KAPALI",
    image: "RESİM",
    gozesnetme: {
      description: `{seconds} saniye boyunca yukarıdaki şeklin<br />kaç
      defa çıktığını sayman gerek<br /><br />`,
      question: `<br />
      Yukarıdaki şekli<br />kaç defa gördünüz?<br /><br />`
    },
    grupokuma: {
      level: "Üstü Kapalı {level} Kelime",
      marquee: "KAYAN YAZI"
    },
    finished: "Bitti",
    hafiza: {
      des1: "Renkli Kareleri Aklınızda Tutun",
      des2: "Kareleri İşaretleyin"
    },
    point: "Puan",
    level: "Seviye",
    total_true: "Toplam Doğru",
    total_false: "Toplam Yanlış:",
    isabet: "İsabet Oranı:",
    reaction: "Şekil Başına Reaksiyon Süresi:",
    seconds: "saniye",
    start_again: "Tekrar Başla",
    hafizandatut: {
      desc: "Ekrandaki kart<br />bir önceki kart ile aynı mı?<br />"
    },
    time: "Süre",
    different: "Farklı",
    same: "Aynı",
    which_bigger: "Hangisi Daha Büyük?",
    timeisend: "Süre Bitti<br /> Puanınız: {point}<br />",
    left: "Soldaki",
    allsame: "İkiside Aynı",
    right: "Sağdaki",
    view_time: "GÖRÜNME SÜRESİ",
    letter_count: "HARF SAYISI",
    harfsayma: {
      description: `Kac adet {currentLetter} var?`
    },
    hizlisecim: {
      description: "Ekrandaki şekil ve renk<br />bir önceki şekil ve renk ile aynı mı?<br />",
      different: "Farklı",
      same: "Aynı"
    },
    text_length: "METİN UZUNLUĞU",
    kelimeavi: {
      description: 'Okuma metninde geçen "{currentLetter}" kelime / kelimelerini bulun'
    },
    siralama: {
      desc: `Görüş alanınızı keskinleştirin ve en yüksek kuleyi inşa edin.
      Kutucuklarda belirecek olan rakamlara küçükten büyüğe göre sırasıyla
      basın.`,
      start: "Anladım, Başlayabiliriz!",
      starat: "Anladım, Başlayabiliriz!"
    },
    tak: {
      placeholder: "Ekranda gördüğünüz kelime/kelimeleri yazınız"
    },
    zikzak: {
      desc: `<br />
      Yukarıdaki rengi<br />kaç defa gördünüz?<br /><br />`,
      dikkat: `<br />
      {time} saniye boyunca yukarıdaki rengin<br />kaç
      defa çıktığını sayman gerek<br /><br />`
    }
  },
  home: {
    exercises: "Egzersizlerim",
    welcome: "Hoşgeldin",
    stats: "Okuma Hızı İstatistikleri",
    last_speed: "Son Okuma Hızı",
    last_under: "Son Anlama Oranı",
    first_speed: "İlk Okuma Hızı",
    first_under: "İlk Anlama Oranı",
    gain: "Gelişim Gidişatı",
    read: {
      title: "Başlamadan Önce Okuma Hızını Ölçmemiz Gerekiyor",
      desc: `Sana kısa bir metin okutacağız ve okuduğun metinle ilgili kısa
      sorular soracağız. Bu test senin okuma hızını tespit etmemize
      yardımcı olacak.`,
      start: "Teste Başla"
    },
    kdk: " k/dk",
    reading_speed: "Okuma Hızı",
    unders: "Anlama Oranı",
    start_date: "Başlangıç Tarihi",
    exam_stats: "Soru Çözüm Hızı İstatistikleri",
    tepki: "Tepki Süresi Gelişimi",
    eniyi: "En İyi:",
    milisaniye: "milisaniye",
    dikkat: "Dikkat & Odaklanma Gelişimi",
    enyuksek: "En Yüksek Puan:",
    hafiza: "Hafıza Gelişimi",
    zihinsel: "Zihinsel Matematik Gelişimi"
  },
  modules: {
    "Odak Okuma": "Odak Okuma",
    "Soru Egzersizi": "Soru Egzersizi",
    "Göz Kasları Esnetme": "Göz Kasları Esnetme",
    "İkili & Üçlü Kolon": "İkili & Üçlü Kolon",
    "Görme Alanı": "Görme Alanı",
    "Göz Ritmi": "Göz Ritmi",
    "Sıralı Nesneler": "Sıralı Nesneler",
    "Say Bakalım": "Say Bakalım",
    "Farkı Bul": "Farkı Bul",
    "Kelime Avı": "Kelime Avı",
    Takistoskop: "Takistoskop",
    "Çoklu Odak": "Çoklu Odak",
    "Çevre Fokus": "Çevre Fokus",
    "Blok Okuma": "Blok Okuma",
    Gölgeleme: "Gölgeleme",
    Gruplama: "Gruplama",
    ZikZak: "ZikZak",
    "Geniş Bakış": "Genis Bakış",
    "Düzelt Bakalım": "Düzelt Bakalım",
    "Kelime Yeterliliği": "Kelime Yeterliliği",
    "Benzer Kelimeler": "Benzer Kelimeler",
    "Hangisi Büyük?": "Hangisi Büyük?",
    Video: "Video",
    "Hızlı Seçim": "Hızlı Seçim",
    "Köstebeği Yakala": "Köstebeği Yakala",
    "Hız Üçgeni": "Hız Üçgeni",
    "Hafıza Kareleri": "Hafıza Kareleri",
    "Dönen Hafıza": "Dönen Hafıza",
    "Kare Okuma": "Kare Okuma",
    "İleri Seviye Kare Okuma": "İleri Seviye Kare Okuma",
    Tekerleme: "Tekerleme",
    "Şiir Okuma": "Şiir Okuma",
    "Haydi Düzeltelim": "Haydi Düzeltelim",
    "İleri Seviye Tekerleme": "İleri Seviye Tekerleme",
    "İleri Seviye Şiir Okuma": "İleri Seviye Şiir Okuma",
    Heceleme: "Heceleme",
    "Serbest Okuma": "Serbest Okuma",
    "Kelime Egzersizi": "Kelime Kutucuğu Egzersizi",
    Bavul: "Bavul",
    "Kar Tanesi": "Kar Tanesi",
    Tangram: "Tangram",
    "İleri Seviye Hızlı Seçim": "İleri Seviye Hızlı Seçim",
    "Sınav Gölgeleme": "Gölgeleme",
    "İleri Seviye Göz Ritmi": "İleri Seviye Göz Ritmi",
    "İleri Seviye Gölgeleme": "İleri Seviye Gölgeleme",
    "İleri Seviye Kelime Avı": "İleri Seviye Kelime Avı",
    "İleri Seviye Serbest Okuma": "İleri Seviye Serbest Okuma"
  },
  speedtest: {
    title: "Hız testine hoş geldiniz",
    description: "Aşağıdaki butona tıkladığınızda süre başlayacaktır. Hazırsanız başlayalım!",
    start: "Başla",
    speed: "Okuma hızınız",
    kd: "Kelime/Dakika",
    time: "Geçen süre {time} saniye",
    desc2: "Metni anlayarak okuduğunuzu düşünüyorsanız metinle ilgili sorulara geçebilirsiniz.",
    hatirlatma: "Anlama seviyeniz %50'nin altındaysa bu metni tekrarlamanız gerekeceğini hatırlatmak isteriz.",
    sorularagec: "sorulara git",
    metnedon: "metne geri dön",
    hesaplamatamam: "Hesaplama tamamlandı",
    anlamaorani: "Anlama Oranı",
    geri: "Geri",
    hesapla: "Hesapla",
    bitti: "Bitti"
  },
  golge: {
    mode_1: "Silinerek Gölgeleme",
    mode_2: "Silinmeden Gölgeleme",
    mode_3: "Okunan Gölgeleme",
    mode_4: "Yazarak Gölgeleme"
  },
  menu: {
    tests: "Testler",
    logout: "Çıkış Yap",
    home: "Anasayfa",
    courses: "Eğitimler",
    exercises: "Egzersizler"
  },
  gelisim: "Okuma Gelişimi",
  sorugelisim: "Soru Okuma Gelişimi"
};



// WEBPACK FOOTER //
// ./src/languages/tr.js